module.exports = __webpack_public_path__ + "ath_game_web/img/Twitter_Logo.ff6ff351.png";